import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Label,
    Row,
    Button,
    Form,
    FormFeedback,
    Alert,
} from "reactstrap";
import { Link } from "react-router-dom";

import caspLogo from "../../assets/images/casp-main-logo.png"
const Login = (props) => {




    return (
        <React.Fragment>
            <div
                className="emailtemplate-bgImg d-flex justify-content-center align-items-center w-100 h-screen"
            // style={{ width: "100%", height: "100vh" }}
            >
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6}>
                            <Card className="card-height">
                                <CardBody className="p-5 text-center card_data">
                                   
                                    <div className="mb-4">
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={caspLogo} alt="" height="50" />
                                        </Link>
                                    </div>
                                    <div className="mb-4">
                                        <h5>Hi, Anisha you have been invited to join organization XYZ  CASP portal</h5>
                                    </div>
                                    <div className="button_des">

                                        <div>
                                            <button  className="m-2 accept">Go to Organization page</button>
                                        </div>

                                        {/* <div>
                                            <button  className="m-2 cancel">Cancel</button>
                                        </div> */}
                                        </div>
                                        

                                </CardBody>
                            </Card>
                        </Col>


                    </Row>
                </Container>

            </div>
        </React.Fragment>
    );
};

export default Login;
